import React, {
  createContext,
  PropsWithChildren,
  useEffect,
  useState,
} from "react";
import { sendForm } from "../../client/client";
import { Questionnaire } from "@shared/types";

export type FormState = Partial<Questionnaire>;

export type FormContextType = {
  formState: FormState;
  updateFormState: (newState: FormState) => void;
  send: () => Promise<Response>;
};

const FormContext = createContext<FormContextType>({
  formState: {},
  updateFormState: () => {},
  send: async () => new Response(),
});

const FormProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [formState, setFormState] = useState<FormState>(() => {
    const savedData = localStorage.getItem("formState");
    // TODO: fallback if saved Data is invalid
    return savedData ? JSON.parse(savedData) : {};
  });

  const updateFormState = (newData: FormState) => {
    setFormState((oldState) => {
      const bodyComplaintPoints =
        newData.gender && newData.gender !== oldState.gender
          ? undefined
          : (newData["body-complaints-map"] ?? oldState["body-complaints-map"]);

      const faceComplaintPoints =
        newData.gender && newData.gender !== oldState.gender
          ? undefined
          : (newData["face-complaints-map"] ?? oldState["face-complaints-map"]);

      return {
        ...oldState,
        ...newData,
        bodyComplaintPoints,
        faceComplaintPoints,
      };
    });
  };

  useEffect(() => {
    localStorage.setItem("formState", JSON.stringify(formState));
  }, [formState]);

  const send = async () => {
    return sendForm(formState).then((response) => {
      if (!response.ok) {
        throw new Error("Error sending form");
      }
      setFormState({});
      return response;
    });
  };

  return (
    <FormContext.Provider value={{ formState, updateFormState, send }}>
      {children}
    </FormContext.Provider>
  );
};

export { FormProvider, FormContext };
